<!-- content -->
<div *ngIf="displayTimeLineChart" class="content">

    <div class="row pt-5">
        <div class="col-12 text-center">
            <h3>{{ 'pages.securitycase.casesTimeline' | translate }}
                <app-help message="{{ 'pages.securitycase.caseTimelineDesc' | translate }}"></app-help>
            </h3>
        </div>

    </div>
    <div class="row p-0" [ngClass]="{'selected': pointSelected}">
        <div class="col-2 text-center p-0">
            <div class="heading-div">
                <p class="heading-paragraphs" [ngClass]="{'active': pointSelected?.yIndex === 0}"><span class="label">{{
                        'pages.securitycase.customer' | translate }}</span></p>
                <p class="heading-paragraphs" [ngClass]="{'active': pointSelected?.yIndex === 1}"><span class="label">{{
                        'pages.securitycase.orangeCyberdefense' | translate }}</span></p>
            </div>
        </div>
        <div class="col-10">

            <highcharts-chart [Highcharts]="highcharts" [options]="timeLineChart" [(update)]="updateDonutFlag"
                style="width: 75%;height: 400px; display: block;"></highcharts-chart>

            <nav class="stepped-process mt-2" [ngClass]="{'stepped-process-dark': isDarkTheme}"
                aria-label="Checkout process">
                <p class="float-start mt-2 me-2 fw-bold d-sm-none">Step</p>
                <ol>
                    <li class="stepped-process-item">
                        <span class="stepped-process-link" alt="Under Investigation" title="Under Investigation">{{
                            'pages.securitycase.underInvestigation' | translate }}</span>
                    </li>
                    <li class="stepped-process-item active">
                        <span class="stepped-process-link" alt="Escalated" title="Escalated">{{
                            'pages.securitycase.escalated' | translate }}</span>
                    </li>
                    <li class="stepped-process-item" [ngClass]="{'active': pointSelected?.xIndex === 2}">
                        <span class="stepped-process-link" alt="Pending OCD" title="Pending OCD">{{
                            'pages.securitycase.pendingOcd' | translate }}</span>
                    </li>
                    <li class="stepped-process-item" [ngClass]="{'active': pointSelected?.xIndex === 3}">
                        <span class="stepped-process-link" alt="Closed" title="Closed">{{
                            'pages.securitycase.closed' | translate }}</span>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
</div>